import { Element, Node } from "@siteimprove/alfa-dom";
import { Style } from "../../style.js";
const { isElement } = Element;
/**
 * @public
 */
export function hasSpecifiedStyle(name, predicate, device, context) {
    return function hasSpecifiedStyle(node) {
        return isElement(node)
            ? Style.from(node, device, context).specified(name).some(predicate)
            : node.parent(Node.flatTree).filter(isElement).some(hasSpecifiedStyle);
    };
}
//# sourceMappingURL=has-specified-style.js.map